import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';
import { UserService } from '../../../auth/_services/user.service'
import { NgProgress } from 'ngx-progressbar';
import { Router } from "@angular/router";


declare let mLayout: any;
@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class HeaderNavComponent implements OnInit, AfterViewInit {
    userId: any;
    user: any;

    constructor(
        private userService: UserService,
        public ngProgress: NgProgress,
        private _router: Router
    ) {

    }
    ngOnInit() {
        this.userId = this.userService.userId;
        this.user = this.userService.user;
        console.log(this.user);

        /** request started */
        this.ngProgress.start();

    }
    ngAfterViewInit() {
        mLayout.initHeader();

    }

    getUserFirstName() {
        if (this.user) {
            if (this.user.fullName) {
                return this.user.fullName.split(" ")[0]
            }
            else return null;
        }
    }

    logOut() {
        console.debug('User clicked Logout');
        this._router.navigate(['logout']).then(() => {
            console.log("Logged Out! ");
        })
    }

}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/header-nav/header-nav.component.ts